<script>
	import { Basket } from "../../lib/stores/basket";
    import { GoogleSdk , GoogleMap, GooglePlacesAutocomplete } from "@beyonk/svelte-googlemaps";
    import { onMount } from "svelte";

    let map;
    let searchValue = "";
    let lat;
    let lng;
    let options = {
        zoom: 16
    };
    let loadMap = true;
    let address = "";
    let center;
    let displaySearchValue;
	
    const google = window.google;
    let selectedAddress;

    const onRecenter = () => {
        if(center) {
            let geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ 'latLng': center }, (results, status) => {
                if (status == window.google.maps.GeocoderStatus.OK) {
                    selectedAddress = results[0];
                    console.log(center.lat());
                    address = (results[0].formatted_address);
                    displaySearchValue = address;
                }
            });
        }
    };

    const getLocation = (place) => {
        console.log(place)
        lat = place.detail.place.geometry.location.lat();
        lng = place.detail.place.geometry.location.lng();
        console.log(lat, lng);
        center = new window.google.maps.LatLng(lat, lng);
        let geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ 'latLng': center }, (results, status) => {
            if (status == window.google.maps.GeocoderStatus.OK) {
                selectedAddress = results[0];
                console.log(selectedAddress);
                address = (results[0].formatted_address);
                displaySearchValue = address;
            }
        });
        map.setCenter(center);
    };
    
    const submit = () => {
        $Basket.shipping = {
            ...$Basket.shipping,
            shippingAddress: $Basket.shipping && $Basket.shipping.shippingAddress ? {...$Basket.shipping.shippingAddress, address, ...center.toJSON()} : {address, ...center.toJSON()},
            cordinates: center.toJSON()
        }
    };
</script>

<form on:submit|preventDefault={submit}>
    <GoogleSdk apiKey="AIzaSyCUYjjCoZLpb8ulRrMbsGT0xfcZb7DdwGk" on:ready={() => {
        center = new window.google.maps.LatLng(12.9715987, 77.5945627)
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(pos => {
                center = new window.google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
            });
        }
    }} />
    <GooglePlacesAutocomplete 
        apiKey="AIzaSyCUYjjCoZLpb8ulRrMbsGT0xfcZb7DdwGk"
        on:placeChanged={(place) => getLocation(place)}
        bind:value={searchValue}
        bind:viewValue={displaySearchValue}
        styleClass="form-control"
        options={
            {
                types: ['geocode'],
                componentRestrictions: { country: 'IN' }
            }
        }
    />

    <div class="maps">
        {#if loadMap}
            <GoogleMap apiKey="AIzaSyCUYjjCoZLpb8ulRrMbsGT0xfcZb7DdwGk" {options} bind:map bind:center on:recentre={onRecenter} bind:value={searchValue}/>	
        {/if}
        
        <div class="map-container" id="add-address-map">
            <img src="/images/address_loc_pin.svg" class="marker-icon" alt="Maps Pin">
        </div>
    </div>
    

    <button class="btn btn-primary bt-lg btn-block" type="submit" disabled={!selectedAddress || selectedAddress && selectedAddress.address_components.find(a => a.types[0]=='postal_code') && selectedAddress.address_components.find(a => a.types[0]=='postal_code').long_name != $Basket.shipping.pincode}>
        Continue
    </button>

    {#if selectedAddress && selectedAddress.address_components.find(a => a.types[0]=='postal_code') && selectedAddress.address_components.find(a => a.types[0]=='postal_code').long_name != $Basket.shipping.pincode}
        <br/>
        <span class="text-danger">Please select a area with pincode {$Basket.shipping.pincode}</span>
    {/if}
</form>

<style>
	.maps {
		width: 100%;
		height: 500px;
		position: relative;
		margin: 10px 0;
        border-radius: 6px;
        overflow: hidden;
	}
	
	.map-container {
		position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
	}
</style>